"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLink = exports.ProtocolsEnum = void 0;
function getConfigKey(key) {
    return process.env[key];
}
var ProtocolsEnum;
(function (ProtocolsEnum) {
    ProtocolsEnum["HTTP"] = "http";
    ProtocolsEnum["HTTPS"] = "https";
    ProtocolsEnum["WS"] = "ws";
    ProtocolsEnum["WSS"] = "wss";
})(ProtocolsEnum = exports.ProtocolsEnum || (exports.ProtocolsEnum = {}));
function makeLink(app, path, protocol = null, getConfig = getConfigKey) {
    var _a, _b;
    if (app == 'brand') {
        app = 'brands';
    }
    if (!path.startsWith('/')) {
        path = '/' + path;
    }
    const publicDomain = getConfig('ALL_APPS_PUBLIC_DOMAIN');
    if (publicDomain) {
        const proto = (_a = getConfig('ALL_APPS_PUBLIC_PROTO')) !== null && _a !== void 0 ? _a : `${ProtocolsEnum.HTTPS}://`;
        return `${proto}${app}.${publicDomain}${path}`;
    }
    if (typeof window === 'object') {
        const firstDot = window.location.hostname.indexOf('.');
        if (firstDot > 0) {
            const linkProtocol = protocol ? `${protocol}:` : window.location.protocol;
            const port = window.location.port ? `:${window.location.port}` : '';
            return `${linkProtocol}//${app}${window.location.hostname.slice(firstDot)}${port}${path}`;
        }
    }
    const env = (_b = getConfig('GID_ENV')) !== null && _b !== void 0 ? _b : getConfig('ENV');
    if (env === 'production') {
        return `${protocol || ProtocolsEnum.HTTPS}://${app}.getitdone.rocks${path}`;
    }
    else if (env === 'staging') {
        return `${protocol || ProtocolsEnum.HTTPS}://${app}.staging.gid.ninja${path}`;
    }
    else if (env == 'test') {
        return `${protocol || ProtocolsEnum.HTTPS}://${app}.testrun.gid.ninja${path}`;
    }
    else if (env == 'development' || env === undefined || env === null) {
        let port;
        switch (app) {
            case 'brands':
                port = 8802;
                break;
            case 'partner':
                port = 8804;
                break;
            case 'admin':
                port = 8801;
                break;
            case 'customer':
                port = 8805;
                break;
            case 'api':
                port = 3000;
                break;
            case 'payment':
                port = 3001;
                break;
            case 'rating':
                port = 3002;
                break;
            case 'order-intake-forms':
                port = 3010;
                break;
        }
        return `${protocol || ProtocolsEnum.HTTP}://localhost:${port}${path}`;
    }
}
exports.makeLink = makeLink;
//# sourceMappingURL=urls.js.map